module.exports = __webpack_public_path__ + "img/icon-model-auth-certificate.1554d5d4.svg";